export default {"src":"/_next/static/media/editing_icon.281c0d6e.svg","height":88,"width":89,"blurWidth":0,"blurHeight":0};